import SliderContainer from 'components/Page/Blog/Part/Slider/SliderContainer';

export default SliderContainer;
